export default "__VITE_ASSET__XfxVM4kL__"